import TeamCreateDoneScreen from '@/screens/TeamCreateDone';

export default function PrivateTeamCreateDoneRoute() {
  return <TeamCreateDoneScreen />;
}
